import React from "react";
import ErrorWrapper from "../../wrapper/ErrorWrapper";
import { Provider } from "react-redux";
import { adminStore } from "../../../redux/store/adminStore";
import QrCanvasImage from "./QrCanvasImage";

const EntryQr = ({ qrDescription, qrLink }) => {
  return (
    <Provider store={adminStore}>
      <ErrorWrapper>
        <QrCanvasImage qrDescription={qrDescription} qrLink={qrLink} />
      </ErrorWrapper>
    </Provider>
  );
};

export default EntryQr;
